export const toCategories = categories =>
  categories.map(category => ({
    value: category.id,
    label: category.name,
    system: category.system,
    code: category.code
  }))

export const toTeams = teams =>
  teams
    ? teams.map(team => ({
        value: team.id,
        label: team.name + ' - ' + team.abbreviation,
        abbreviation: team.abbreviation,
        count: team.usersCount
      }))
    : []
